/*
*值key和数组的value进行匹配,匹配成功则返回数组的name，
* 要求数据格式[{name:'',value:''}]
*/
function Mate(arry,key){
    for(let item of arry){
        if(item.value == key){
            return item.name
        }
    }
}

export default Mate